module.exports = __webpack_public_path__ + "static/media/pottencial.48fe3ae1.svg";